// extracted by mini-css-extract-plugin
module.exports = {"modal":"VerifyModal_modal__cFWx_","modalClose":"VerifyModal_modalClose__iAEnH","text":"VerifyModal_text__AUDXl"};